import { PostAPI } from 'Components/Helper/Helpers';

export const GetLocationName = async (request) => {
    return PostAPI(request, 'GetLocationName/GetLocationName');
};